package com.eladfinish.bible.contest.screens.search.ui

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.extensions.endsWithEmoji
import com.eladfinish.bible.contest.screens.search.model.Sign
import com.eladfinish.bible.contest.ui.components.HorizontalScrollbarContainer
import com.eladfinish.bible.contest.ui.components.RightToLeftRow
import com.eladfinish.bible.contest.ui.components.buttons.ItemButtonTextOutline
import com.eladfinish.bible.contest.ui.components.mouseWheelHorizontalScroll
import com.eladfinish.bible.contest.ui.extensions.horizontalFadingEdge
import kotlinx.collections.immutable.ImmutableList

@Composable
internal fun NikudAndTeamimContainer(
    signs: ImmutableList<Sign>,
    scrollState: ScrollState,
    onSignClick: (String) -> Unit = {},
    onSignLongClick: (String) -> Unit = {},
) {
    val chunks = signs.chunked(size = signs.size / 2)

    HorizontalScrollbarContainer(
        scrollState = scrollState,
        layoutDirection = LayoutDirection.Rtl,
    ) {
        RightToLeftRow(
            modifier = Modifier
                .horizontalFadingEdge(
                    scrollState = scrollState,
                    length = 20.dp,
                    edgeColor = Color.Black,
                )
                .mouseWheelHorizontalScroll(scrollState)
                .horizontalScroll(scrollState),
        ) {
            Column {
                repeat(times = chunks.size) {
                    Row {
                        chunks[it].forEach { sign ->
                            val text = sign.display
                            ItemButtonTextOutline(
                                modifier = Modifier
                                    .padding(0.5.dp)
                                    .size(width = 36.dp, height = 40.dp),
                                text = text,
                                textColor = Color.Black,
                                fontSize = 22.sp,
                                borderWidth = 1,
                                onClick = {
                                    onSignClick(text.takeLast(1.takeUnless { text.endsWithEmoji() } ?: 2))
                                },
                                onLongClick = {
                                    onSignLongClick(sign.value)
                                },
                            )
                        }
                    }
                }
            }
        }
    }
}
